import * as actionTypes from '../constants/actionTypes';

export default(state = {}, action) => {
    switch (action.type) {
        case actionTypes.SET_INITIAL_URL:
            return {
                ...state,
                initialUrl: action.payload
            };
        default:
            return state;
    }
};